import React from 'react'
import FormSelect from 'components/forms/bases/FormSelect'
import { connect } from 'react-redux';
import { selectFontFamily } from 'store/preferences/selectors'

const mapStateToProps = (state) => ({
  fontFamily: selectFontFamily(state)
});

const FontFamilySelector = connect(
  mapStateToProps,
)(
  ({
    fontFamily,
    value,
    onChange,
  }) => {
    return (
      <FormSelect
        label="Font Family"
        value={value}
        onChange={onChange}
        options={fontFamily}
      />
    )
  }
)

FontFamilySelector.propTypes = {}
FontFamilySelector.defaultProps = {}

export default FontFamilySelector



// WEBPACK FOOTER //
// ./src/components/forms/FontFamilySelector.js